import { BRAND } from '../../../constants'
import { ErrorMessage } from '../../UI/index'
import { useRef, useState } from 'react'
import { useClickOutside } from '../../../hooks/useClickOutside'
import { MegaMenu as MegaMenuType, Menu as MenuType } from '../../../models/interfaces/MegaMenu.interface'
import SectionTitle from './SectionTitle'
import DropDown from './DropDown'

type MegaMenuProps = {
  megaMenu: MegaMenuType
  isHomepage?: boolean
}

const MegaMenu = ({ megaMenu, isHomepage = false }: MegaMenuProps) => {
  if (!megaMenu) {
    return <ErrorMessage />
  }

  const menu = useRef(null)

  // filter out falsy values
  const menus = megaMenu.menus.filter((menu) => menu)

  const [activeMegaMenu, setActiveMegaMenu] = useState<MenuType | null>(null)

  useClickOutside(menu, () => {
    setActiveMegaMenu(null)
  })

  const handleOption = (option: MenuType) => {
    if (activeMegaMenu && option.title === activeMegaMenu.title) {
      setActiveMegaMenu(null)
      return
    }

    setActiveMegaMenu(option)
  }

  return (
    <div className={activeMegaMenu ? 'mega-menu-selected' : 'mega-menu'}>
      <nav className='nav' ref={menu}>
        <ul className='unordered-list' onClick={() => setActiveMegaMenu(null)}>
          {menus.map((menu) => (
            <li tabIndex={0} className='menu-list-item' key={`menu-list-item-${menu.id}`}>
              <SectionTitle
                title={menu.title}
                activeMegaMenu={activeMegaMenu}
                isHomepage={isHomepage}
                handleClick={() => handleOption(menu)}
              />
            </li>
          ))}
        </ul>
        <DropDown menu={activeMegaMenu} />
      </nav>
      <style jsx>
        {`
          .mega-menu {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 36px;
            background-color: ${isHomepage ? 'transparent' : 'white'};
            border: 1px solid ${isHomepage ? '#f5f5f51a' : '#f1f1f1'};
            z-index: 100;
            position: absolute;
          }
          .mega-menu-selected {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 36px;
            background-color: #ffffff;
            border: 1px solid #f5f5f51a;
          }
          .unordered-list {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            background-color: transparent;
            gap: 30px;
            list-style: none;
            padding: 0;
            z-index: 400;
          }
          .menu-list-item {
            display: flex;
            z-index: 500;
          }
          .nav {
            background-color: transparent;
            max-width: calc(${BRAND.layout.content}px + 64px);
            width: 100%;
            padding: 0 32px;
            overflow-x: auto;
          }
          @media screen and (max-width: ${BRAND.media.average}px) {
            .list {
              margin: 0px 16px 0px 0px;
            }
          }
          @media screen and (max-width: ${BRAND.media.small}px) {
            .unordered-list {
              width: 90vw;
              align-items: flex-start;
            }
            .mega-menu {
              width: 100%;
            }
            .menu-list-item {
              margin: 0px 10px 0px 0px;
            }
            .nav {
              background-color: transparent;
              padding: 0 24px;
            }
          }
        `}
      </style>
    </div>
  )
}

export default MegaMenu
